import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Tab, Nav, Form, Button } from "react-bootstrap";
import ReactSlider from "react-slider";
import { useLocation, useNavigate } from "react-router-dom"; // <-- for reading URL params and navigation
import Sidebar from "./Sidebar";
import ToolsCaption from "./ToolsCaption";
import ToolsIdea from "./ToolsIdea";
import ToolsProfile from "./ToolsProfile";
import ToolsStory from "./ToolsStory";
import ToolsDownload from "./ToolsDownload";
import ToolsTrends from "./ToolsTrends";
import ToolsPhoto from "./ToolsPhoto";
import ToolsCollab from './ToolsCollab';

import axios from "axios";	
import { useLanguage } from "../contexts/LanguageContext";

const Tools = () => {
  const L = useLanguage();
  const navigate = useNavigate();
  const [captionValue, setCaptionValue] = useState(0);
  const [ideaValue, setIdeaValue] = useState(0);
  const [profileValue, setProfileValue] = useState(0);
  const [storyValue, setStoryValue] = useState(0);
  const [downloadValue, setDownloadValue] = useState("");
  const [profile, setProfile] = useState(null);
  const [isPro, setIsPro] = useState(false);
  const [isBasic, setIsBasic] = useState(false);
  
  // Fetch profile data on component mount
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) return;
        
        const response = await fetch(`https://api.viralgpt.com/auth/profile`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        
        if (response.ok) {
          const data = await response.json();
          const userProfile = data.profile;
          setProfile(userProfile);
          
          // Check if any of the user's socials has pro or basic rank
          if (userProfile && userProfile.socials) {
            for (const social of Object.values(userProfile.socials)) {
              if (social.planName === 'pro') {
                setIsPro(true);
                setIsBasic(true); // Pro users also have basic access
                break;
              } else if (social.planName === 'basic') {
                setIsBasic(true);
              }
            }
          }
        }
      } catch (error) {
        console.log('Could not fetch profile:', error);
      }
    };
    
    fetchProfile();
  }, []);
  
  // Define which tools are AI tools (require pro) and which require basic
  const proTools = ['caption', 'idea', 'profile', 'photo', 'collab', 'story', 'download'];
  const basicTools = ['trends']; // Trends only requires basic
  
  // Function to check if a tool requires pro
  const isProTool = (toolKey) => proTools.includes(toolKey);
  const isBasicTool = (toolKey) => basicTools.includes(toolKey);
  
  // Function to check if user has access to a tool
  const hasAccess = (toolKey) => {
    if (isProTool(toolKey)) return isPro;
    if (isBasicTool(toolKey)) return isBasic;
    return true; // Free tools
  };
  
  // Handle upgrade click
  const handleUpgrade = () => {
    navigate('/dashboard/upgrade');
  };
  
  const handleUpgradeBasic = () => {
    navigate('/dashboard/upgrade');
  };



  const [likesValue, setLikesValue] = useState(0);
  const [viewsValue, setViewsValue] = useState(0);
  const [commentsValue, setCommentsValue] = useState(0);
  const [postLink, setPostLink] = useState("");



  // Read "mode" from query param (?mode=likes/views/comments)
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const modeParam = queryParams.get("mode");

  // We'll ensure it's one of the 3 valid tabs; otherwise default to "likes"
  const validModes = ["caption", "idea", "profile", "trends", "photo", "collab", "story", "download"];
  const defaultKey = validModes.includes(modeParam) ? modeParam : "trends";

  // Handler for "Start Delivery"
  const handleStartDelivery = (type) => {
    let selectedValue;
    if (type === "caption") selectedValue = captionValue;
    if (type === "idea") selectedValue = ideaValue;
    if (type === "profile") selectedValue = profileValue;
	if (type === "story") selectedValue = storyValue;
	if (type === "download") selectedValue = downloadValue;

    alert(
      L.tools.startingDelivery(type, selectedValue, postLink)
    );
  };






  const tools = [
    { key: 'trends', emoji: '🎯', label: L.tools.items.trends.label, desc: L.tools.items.trends.desc, Component: ToolsTrends, tier: 'basic' },
    { key: 'story', emoji: '🕵️', label: L.tools.items.story.label, desc: L.tools.items.story.desc, Component: ToolsStory, tier: 'pro' },
    { key: 'download', emoji: '📥', label: L.tools.items.download.label, desc: L.tools.items.download.desc, Component: ToolsDownload, tier: 'pro' },
    { key: 'caption', emoji: '📝', label: L.tools.items.caption.label, desc: L.tools.items.caption.desc, Component: ToolsCaption, tier: 'pro' },
    { key: 'idea', emoji: '🧠', label: L.tools.items.idea.label, desc: L.tools.items.idea.desc, Component: ToolsIdea, tier: 'pro' },
    { key: 'profile', emoji: '🪄', label: L.tools.items.profile.label, desc: L.tools.items.profile.desc, Component: ToolsProfile, tier: 'pro' },
    { key: 'photo', emoji: '📸', label: L.tools.items.photo.label, desc: L.tools.items.photo.desc, Component: ToolsPhoto, tier: 'pro' },
    { key: 'collab', emoji: '🤝', label: L.tools.items.collab.label, desc: L.tools.items.collab.desc, Component: ToolsCollab, tier: 'pro' },
  ];

  const renderLockedOverlay = (tool) => {
    const isBasicGate = tool.tier === 'basic';
    return (
      <div className="position-relative" style={{ minHeight: '400px' }}>
        <div style={{ filter: 'blur(8px)', pointerEvents: 'none' }}>
          <tool.Component />
        </div>
        <div className="position-absolute top-50 start-50 translate-middle text-center w-100 px-3" style={{zIndex: 2}}>
          <div style={{
            background: '#fff', borderRadius: '16px', padding: '32px 28px', maxWidth: '380px', margin: '0 auto',
            boxShadow: '0 8px 30px rgba(50,50,93,0.12), 0 4px 12px rgba(0,0,0,0.06)',
            border: '1px solid #e3e8ee',
          }}>
            <div style={{
              width: '48px', height: '48px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: 'linear-gradient(135deg, #f5f3ff, #ede9fe)', margin: '0 auto 16px',
            }}>
              <i className="fas fa-lock" style={{color: '#635bff', fontSize: '1.1rem'}}></i>
            </div>
            <h4 style={{fontWeight: 700, color: '#0a2540', fontSize: '1.1rem', marginBottom: '6px'}}>
              {isBasicGate ? L.tools.basicFeature : L.tools.proFeature}
            </h4>
            <p style={{color: '#68778d', fontSize: '0.85rem', marginBottom: '20px', lineHeight: 1.5}}>
              {L.tools.upgradeToUnlock(isBasicGate ? L.tools.tierBasicOrPro : L.tools.tierPro, tool.desc)}
            </p>
            <button 
              onClick={isBasicGate ? handleUpgradeBasic : handleUpgrade}
              style={{
                width: '100%', padding: '12px', borderRadius: '10px', border: 'none', fontWeight: 700, fontSize: '0.88rem',
                cursor: 'pointer', color: '#fff', transition: 'all 0.15s ease',
                background: 'linear-gradient(135deg, #635bff 0%, #8b5cf6 100%)',
                boxShadow: '0 2px 8px rgba(99,91,255,0.3)',
              }}
            >
              <i className={`fas ${isBasicGate ? 'fa-arrow-up' : 'fa-crown'} me-2`} style={{fontSize: '0.75rem'}}></i>
              {L.tools.upgradeNow}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
	<>
    <Container className="py-3">
      <Tab.Container defaultActiveKey={defaultKey}>
        {/* Scrollable tool tabs */}
        <div style={{overflowX: 'auto', marginBottom: '16px', WebkitOverflowScrolling: 'touch'}}>
          <div style={{
            display: 'flex', gap: '6px', padding: '4px', minWidth: 'max-content',
            background: '#fff', borderRadius: '12px', border: '1px solid #e3e8ee',
            boxShadow: '0 2px 4px rgba(50,50,93,0.06)',
          }}>
            {tools.map(tool => {
              const locked = (tool.tier === 'pro' && !isPro) || (tool.tier === 'basic' && !isBasic);
              return (
                <Nav.Item key={tool.key}>
                  <Nav.Link eventKey={tool.key} style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                    padding: '12px 14px', borderRadius: '10px', cursor: 'pointer', position: 'relative',
                    minWidth: '90px', textAlign: 'center', border: 'none', transition: 'all 0.15s ease',
                  }}>
                    <span style={{fontSize: '1.4rem', marginBottom: '3px'}}>{tool.emoji}</span>
                    <span style={{fontSize: '0.72rem', fontWeight: 600, whiteSpace: 'nowrap', color: '#0a2540'}}>{tool.label}</span>
                    {locked && (
                      <span style={{
                        position: 'absolute', top: '4px', right: '4px',
                        padding: '1px 5px', borderRadius: '4px', fontSize: '0.55rem', fontWeight: 700,
                        background: tool.tier === 'pro' ? 'linear-gradient(135deg, #635bff, #8b5cf6)' : '#0a2540',
                        color: '#fff',
                      }}>
                        {tool.tier === 'pro' ? L.tools.badgePro : L.tools.badgeBasic}
                      </span>
                    )}
                  </Nav.Link>
                </Nav.Item>
              );
            })}
          </div>
        </div>

        {/* Tab content */}
        <div style={{
          background: '#fff', borderRadius: '12px', border: '1px solid #e3e8ee',
          boxShadow: '0 2px 4px rgba(50,50,93,0.06)', overflow: 'hidden',
        }}>
          <Tab.Content>
            {tools.map(tool => {
              const locked = (tool.tier === 'pro' && !isPro) || (tool.tier === 'basic' && !isBasic);
              return (
                <Tab.Pane key={tool.key} eventKey={tool.key}>
                  {locked ? renderLockedOverlay(tool) : <tool.Component />}
                </Tab.Pane>
              );
            })}
          </Tab.Content>
        </div>
      </Tab.Container>
    </Container>
	</>
  );
};

export default Tools;
